<template>
  <div class="bjex-main" v-loading="loading">
    <el-page-header @back="goBack"> </el-page-header>
    <el-row :gutter="20">
      <el-col :span="24">
        <el-tabs v-model="activeName">
          <el-tab-pane label="基础信息" name="1"></el-tab-pane>
          <el-tab-pane label="配套资源" name="2" v-if="ruleForm.id !== ''"></el-tab-pane>
          <el-tab-pane label="测评题" name="3" v-if="ruleForm.id !== ''"></el-tab-pane>
          <el-tab-pane label="相关作业" name="4" v-if="ruleForm.id !== ''"></el-tab-pane>
        </el-tabs>
        <div v-if="activeName == '1'">
          <div v-if="isDetail" style="padding: 20px">
            <el-descriptions :column="1">
              <el-descriptions-item label="名称">{{
                seeItem.bookName
              }}</el-descriptions-item>
              <el-descriptions-item label="封面"><img style="width: 200px; height: 240px"
                  :src="seeItem.serverHttp + seeItem.bookImgUrl" /></el-descriptions-item>
              <el-descriptions-item label="适合年级">{{
                seeItem.bookGradesName
              }}</el-descriptions-item>
              <el-descriptions-item label="图书分类" v-if="seeItem.readClassifyBookList.length > 0">{{
                seeItem.readClassifyBookList[0].classifyName
              }}</el-descriptions-item>
              <el-descriptions-item label="图书等级">{{
                getNameById(seeItem.bookLevel, bookLevelList, "code", "name")
              }}</el-descriptions-item>
              <el-descriptions-item label="所属专栏">{{
                getNamesByIds(
                  seeItem.specialColumnCode,
                  specialColumnList,
                  "code",
                  "name"
                )
              }}</el-descriptions-item>
              <el-descriptions-item label="阅读分级(星星值)">
                <span style="margin-right: 5px">开始阅读星星值
                  {{ seeItem.starRuleObj.startReadNumber }}颗</span>
                <span style="margin-right: 5px">结束阅读星星值
                  {{ seeItem.starRuleObj.endReadNumber }}颗</span>
                <span style="margin-right: 5px">提交读后感星星值
                  {{ seeItem.starRuleObj.summitFeelNumber }}颗</span>
                <span style="margin-right: 5px">完成测评星星值
                  {{ seeItem.starRuleObj.complatePaperNumber }}颗</span>
              </el-descriptions-item>
              <el-descriptions-item label="作者">{{
                seeItem.bookAuthor
              }}</el-descriptions-item>
              <el-descriptions-item label="出版社">{{
                seeItem.publishingName
              }}</el-descriptions-item>
              <el-descriptions-item label="编号">{{
                seeItem.bookCode
              }}</el-descriptions-item>
              <el-descriptions-item label="图书字数">{{
                seeItem.wordNumber
              }}</el-descriptions-item>
              <el-descriptions-item label="简介">
                <div class="richText" v-html="seeItem.bookIntro"></div>
              </el-descriptions-item>
            </el-descriptions>
          </div>
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm" v-else>
            <el-form-item label="名称" prop="bookName">
              <el-input v-model="ruleForm.bookName" placeholder="请输入书籍名称" :maxlength="20" :show-word-limit="true"
                style="width: 194px"></el-input>
            </el-form-item>
            <el-form-item label="图书分类" prop="classifyIdList">
              <el-cascader ref="tree" clearable v-model="ruleForm.classifyIdList" placeholder="请选择图书分类"
                :options="options" @change="opsChange"></el-cascader>
            </el-form-item>
            <el-form-item label="图书等级" prop="bookLevel">
              <el-select v-model="ruleForm.bookLevel" placeholder="请选择图书等级" clearable>
                <el-option v-for="item in bookLevelList" :key="item.id" :label="item.name" :value="Number(item.code)">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="适用年级" prop="bookGrades">
              <el-checkbox-group v-model="ruleForm.bookGrades">
                <el-checkbox v-for="item in gradelist" :key="item.gradeId" :label="String(item.gradeId)">{{ item.name
                  }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="所属专栏" prop="specialColumnCode">
              <el-checkbox-group v-model="ruleForm.specialColumnCode">
                <el-checkbox v-for="item in specialColumnList" :key="item.id" :label="item.code">{{ item.name }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="开始阅读星星值" prop="startReadNumber">
              <el-input-number :disabled="ruleForm.publishStatus && ruleForm.publishStatus == 1
                " :min="1" v-model="ruleForm.startReadNumber" :step="1" step-strictly></el-input-number>
              星
            </el-form-item>
            <el-form-item label="结束阅读星星值" prop="endReadNumber">
              <el-input-number :disabled="ruleForm.publishStatus && ruleForm.publishStatus == 1
                " :min="1" v-model="ruleForm.endReadNumber" :step="1" step-strictly></el-input-number>
              星
            </el-form-item>
            <el-form-item label="提交读后感星星值" prop="summitFeelNumber">
              <el-input-number :disabled="ruleForm.publishStatus && ruleForm.publishStatus == 1
                " :min="1" v-model="ruleForm.summitFeelNumber" :step="1" step-strictly></el-input-number>
              星
            </el-form-item>
            <el-form-item label="完成测评星星值" prop="complatePaperNumber">
              <el-input-number :disabled="ruleForm.publishStatus && ruleForm.publishStatus == 1
                " :min="1" v-model="ruleForm.complatePaperNumber" :step="1" step-strictly></el-input-number>
              星
            </el-form-item>
            <el-form-item label="作者" prop="bookAuthor">
              <el-input v-model="ruleForm.bookAuthor" placeholder="请输入作者名称" style="width: 194px"></el-input>
            </el-form-item>
            <el-form-item label="出版社" prop="publishingId">
              <el-select v-model="ruleForm.publishingId" placeholder="请选择出版社名称">
                <el-option v-for="item in publishingList" :key="item.id" :label="item.publishingName" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="编号" prop="bookCode">
              <el-input v-model="ruleForm.bookCode" placeholder="请输入编号" style="width: 194px"></el-input>
            </el-form-item>
            <el-form-item label="封面" prop="bookImgUrl">
              <el-upload class="avatar-uploader" accept=".jpg,.jpeg,.png,.gif,.bmp,.JPG,.JPEG,.PBG,.GIF,.BMP"
                :headers="headers" :data="datas" :action="urls" :show-file-list="false"
                :on-success="handleAvatarSuccess2">
                <img v-if="ruleForm.bookImgUrl" :src="ruleForm.serverHttp + ruleForm.bookImgUrl" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon hjaskg"></i>
              </el-upload>
              <div class="huise" style="width: fit-content">
                建议尺寸200px*240px，显示效果最佳。支持jpg、jpeg、png，图片大小不超过5M
              </div>
            </el-form-item>
            <el-form-item label="图书字数" prop="wordNumber">
              <el-input v-model="ruleForm.wordNumber" type="number" placeholder="请输入图书字数"
                style="width: 194px"></el-input>
            </el-form-item>
            <el-form-item label="简介">
              <div style="border: 1px solid #ccc; width: 800px">
                <Toolbar style="border-bottom: 1px solid #ccc" :editor="editor1" :defaultConfig="toolbarConfig"
                  :mode="mode" />
                <Editor style="height: 400px; overflow-y: hidden" v-model="ruleForm.bookIntro"
                  :defaultConfig="editorConfig" :mode="mode" @onCreated="onCreated1" />
              </div>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm('ruleForm')" size="small">保存</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div v-if="activeName == '2'">
          <!-- <div style="padding-left: 10px" v-if="!isDetail">
            <el-row :gutter="20" style="margin-bottom: 20px">
              <el-col :span="2" class="center heiji1 xiao-size xu cursor" v-for="list in Restypelist" :key="list.id"
                @click.native="
                  (fileList = []), (dialogVisible3 = true), (resType = list);
                ">
                <el-col :span="24">
                  <el-button type="text">+ {{ list.name }}</el-button>
                </el-col>
              </el-col>
            </el-row>
          </div> -->
          <div v-if="resList.length==0">本书无资源 <el-button type="primary" @click="tianjia" size="small">添加资源</el-button> <el-button type="primary" @click="dialogVisible6=true" size="small">从资源库选择</el-button></div>
          <div v-if="resList.length>0">本书有{{resList.length}}个资源 <el-button type="primary" @click="tianjia" size="small">添加资源</el-button> <el-button type="primary" @click="dialogVisible6=true" size="small">从资源库选择</el-button></div>
          <el-table :data="resList" border stripe style="width: 100%" highlight-current-row>
            <el-table-column prop="resTitle" label="资源名称" align="center"></el-table-column>
            <el-table-column label="资源类型" align="center" prop="resTypeTitle"></el-table-column>
            <el-table-column prop="createTime" label="上传时间" align="center"></el-table-column>
            <el-table-column label="资源" align="center">
              <template slot-scope="scope">
                <el-popover placement="top-start" width="200" trigger="hover" content="word、excel、ppt、pdf等文件需下载后在本地查看。">
                  <el-button slot="reference" type="text" @click="preview(scope.row,list)" v-for="(list,index) in scope.row.resourceList" v-bind:key="index">{{list.fileName}}</el-button>
                </el-popover>
                <!-- <el-button type="text" @click="removeresource(scope.row)" >解除关联</el-button> -->
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button type="text" @click="removeresource(scope.row)" >解除关联</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="activeName == '3'">
          <div class="spb">
            <div>
              <span style="margin-right: 10px">
                题目总数（{{ ruleForm.questionNumber }}）
              </span>
              <span style="margin-right: 10px">
                较易（{{ ruleForm.simpleNumber }}）
              </span>
              <span style="margin-right: 10px">
                中等（{{ ruleForm.normalNumber }}）
              </span>
              <span style="margin-right: 10px">
                较难（{{ ruleForm.difficultyNumber }}）
              </span>
            </div>
            <div v-if="!isDetail">
              <el-button type="primary" size="small" @click="daoru">一键导入</el-button>
              <el-button type="primary" @click="setcp" size="small">测评设置</el-button>
              <el-button type="primary" @click="dialogVisible1 = true" size="small">添加试题</el-button>
            </div>
          </div>
          <div v-if="paperRule">
            测评设置：<span class="mr-10">题目总数：{{
              Number(paperRule.difficultyNumber) +
              Number(paperRule.normalNumber) +
              Number(paperRule.simpleNumber)
            }}</span>
            <span class="mr-10">较易题随机数：{{ paperRule.simpleNumber }}</span>
            <span class="mr-10">中等题随机数：{{ paperRule.normalNumber }}</span>
            <span class="mr-10">较难题随机数：{{ paperRule.difficultyNumber }}</span>
            <span class="mr-10">附加题随机数：{{ paperRule.isPassNumber }}</span><br />
            <span class="mr-10">答题时间：{{ paperRule.answerTime }}分钟</span>
            <span class="mr-10">通过规则：答对{{ paperRule.isPassNumber }}道题</span>
            <span class="mr-10">允许测评次数：{{ paperRule.paperNumber || 0 }}次</span>
          </div>
          <el-divider></el-divider>
          <div v-for="(item, index) in questionList" :key="item.id">
            <div class="spb questionItem">
              <div style="font-size: 14px; font-weight: 800">
                {{ index + 1 }}、{{ item.questionName }} (难易程度：{{
                  getNamesByIds(
                    [item.questionLevel],
                    levelList,
                    "code",
                    "name"
                  ).join(",")
                }}) ({{
                  item.questionType === 0
                    ? "单选"
                    : item.questionType === 1
                      ? "多选"
                      : "问答"
                }})
              </div>
              <div v-if="!isDetail">
                <el-button type="text" @click="editQuestion(item)">编辑</el-button>
                <el-button type="text" @click="delQuestion(item)">删除</el-button>
              </div>
            </div>

            <div class="questionItem">
              <span v-for="option in item.readQuestionOptionsList" :key="option.id" style="margin-right: 10px">
                {{ option.optionLabel }}：{{ option.optionName }}</span>
            </div>
            <div class="questionItem">答案：{{ item.rightAnswer }}</div>
            <div class="questionItem">
              解析：{{
                item.questionAnalysis == "" ? "无" : item.questionAnalysis
              }}
            </div>
            <el-divider></el-divider>
          </div>
          <!-- <el-button type="primary" @click="saveReadQuestion()" size="small">保存</el-button> -->
        </div>
      </el-col>
    </el-row>
    <el-dialog title="测评设置" :modal-append-to-body="false" :visible.sync="dialogVisible" :before-close="cpClose">
      <el-form :model="cpForm" :rules="cprules" ref="cpForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="较易题随机数" prop="simpleNumber">
          <el-input v-model="cpForm.simpleNumber" type="number" :min="0" :max="ruleForm.simpleNumber"
            placeholder="请输入较易题随机数" style="width: 194px"></el-input>
          题，当前总题数：{{ ruleForm.simpleNumber }}
        </el-form-item>
        <el-form-item label="中等题随机数" prop="normalNumber">
          <el-input v-model="cpForm.normalNumber" type="number" :min="0" :max="ruleForm.normalNumber"
            placeholder="请输入中等题随机数" style="width: 194px"></el-input>
          题，当前总题数：{{ ruleForm.normalNumber }}
        </el-form-item>
        <el-form-item label="较难题随机数" prop="difficultyNumber">
          <el-input v-model="cpForm.difficultyNumber" type="number" :min="0" :max="ruleForm.difficultyNumber"
            placeholder="请输入较难题随机数" style="width: 194px"></el-input>
          题，当前总题数：{{ ruleForm.difficultyNumber }}
        </el-form-item>
        <el-form-item label="附加题数量" prop="additionalNumber">
          <el-input v-model="cpForm.additionalNumber" type="number" :min="1" :max="ruleForm.additionalNumber"
            placeholder="请输入附加题数量" style="width: 194px"></el-input>
          题，当前总题数：{{ ruleForm.additionalNumber }}
        </el-form-item>
        <el-form-item label="答题时间" prop="answerTime">
          <el-input-number :min="3" :max="30" v-model="cpForm.answerTime" :step="1" step-strictly></el-input-number>
          分钟
        </el-form-item>
        <el-form-item label="通过题数" prop="isPassNumber">
          <el-input v-model="cpForm.isPassNumber" type="number" :min="1" :max="Number(cpForm.simpleNumber) +
            Number(cpForm.normalNumber) +
            Number(cpForm.difficultyNumber)
            " placeholder="请输入通过题数" style="width: 194px"></el-input>
          题(试卷总题数
          {{
            Number(cpForm.simpleNumber) +
              Number(cpForm.normalNumber) +
              Number(cpForm.difficultyNumber)
              ? Number(cpForm.simpleNumber) +
              Number(cpForm.normalNumber) +
              Number(cpForm.difficultyNumber)
              : 0
          }}
          )
        </el-form-item>
        <el-form-item label="允许测评次数" prop="paperNumber">
          <el-input v-model="cpForm.paperNumber" type="number" :min="1" placeholder="请输入允许测评次数"
            style="width: 194px"></el-input>
          次
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="
          dialogVisible = false;
        resetCP();
        " size="small">取 消</el-button>
        <el-button type="primary" @click="setUpPaperRule" size="small">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="" :modal-append-to-body="false" :visible.sync="dialogVisible1" :before-close="stClose">
      <el-form :model="stForm" :rules="strules" ref="stForm" label-width="120px" class="demo-ruleForm stForm">
        <el-form-item label="难易程度" prop="questionLevel">
          <el-radio-group v-model="stForm.questionLevel">
            <el-radio :label="Number(item.code)" v-for="item in levelList" :key="item.id">{{ item.name }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="附加题" prop="isAdditional">
          <el-switch v-model="stForm.isAdditional" :active-value="1" :inactive-value="0">
          </el-switch>
        </el-form-item>
        <el-form-item label="类型" prop="questionType">
          <el-radio-group v-model="stForm.questionType" @change="resetOptions">
            <el-radio :label="0">单选</el-radio>
            <el-radio :label="1">多选</el-radio>
            <el-radio :label="2">问答</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="题干" prop="questionName">
          <el-input v-model="stForm.questionName" size="small" placeholder="请输入题干"></el-input>
        </el-form-item>
        <el-form-item label="答案" prop="rightAnswer" v-if="stForm.questionType === 2">
          <el-input v-model="stForm.rightAnswer" placeholder="请输入答案" size="small"></el-input>
          <span style="color: red" v-if="stForm.isAdditional == 0">非附加题答案必填！</span>
        </el-form-item>
        <el-form-item label="选项" prop="readQuestionOptionsList" v-if="stForm.questionType !== 2">
          <el-radio-group v-model="radio" v-if="stForm.questionType === 0">
            <i class="el-icon-circle-plus-outline" style="font-size: 16px" @click="pushOption()"
              v-if="stForm.readQuestionOptionsList.length == 0"></i>
            <div v-for="(item, index) in stForm.readQuestionOptionsList" :key="index"
              style="display: flex; align-items: center; margin-bottom: 10px">
              <div style="width: 350px">
                <el-input v-model="item.optionName" style="width: 200px; margin-right: 5px" size="small"></el-input>
                <i class="el-icon-delete" style="margin: 0 10px; font-size: 16px"
                  @click="delOption(item, stForm, index, 1)"></i>
                <i class="el-icon-circle-plus-outline" style="font-size: 16px" @click="pushOption()" v-if="
                  index == stForm.readQuestionOptionsList.length - 1 &&
                  stForm.readQuestionOptionsList.length < 10
                "></i>
              </div>
              <el-radio :label="index">是否是正确答案</el-radio>
            </div>
          </el-radio-group>
          <el-checkbox-group v-model="checkBox" v-if="stForm.questionType === 1">
            <i class="el-icon-circle-plus-outline" style="font-size: 16px" @click="pushOption()"
              v-if="stForm.readQuestionOptionsList.length == 0"></i>
            <div v-for="(item, index) in stForm.readQuestionOptionsList" :key="index"
              style="display: flex; align-items: center; margin-bottom: 10px">
              <div style="width: 350px">
                <el-input v-model="item.optionName" style="width: 200px; margin-right: 5px" size="small"></el-input>
                <i class="el-icon-delete" style="margin: 0 10px; font-size: 16px"
                  @click="delOption(item, stForm, index, 2)"></i>
                <i class="el-icon-circle-plus-outline" style="font-size: 16px" @click="pushOption()" v-if="
                  index == stForm.readQuestionOptionsList.length - 1 &&
                  stForm.readQuestionOptionsList.length < 10
                "></i>
              </div>
              <el-checkbox :label="index">是否是正确答案</el-checkbox>
            </div>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="解析" style="margin-top: 20px">
          <el-input v-model="stForm.questionAnalysis" type="textarea" placeholder="请输入解析"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="
          dialogVisible1 = false;
        resetST();
        " size="small">取 消</el-button>
        <el-button type="primary" @click="saveReadQuestion" size="small">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="文件预览" :modal-append-to-body="false" :visible.sync="dialogVisible2">
      <video controls :src="prevFile.url" v-if="prevFile.fileType == 'video'" width="100%"></video>
      <img :src="prevFile.url" v-if="prevFile.fileType == 'image'" width="100%" />
    </el-dialog>
    <el-dialog :title="'上传' + resType.name" :modal-append-to-body="false" :visible.sync="dialogVisible3"
      :before-close="fileClose">
      <!-- <el-form>
        <el-form-item label="允许下载" prop="isDown">
          <el-radio-group v-model="dataw.isDown">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form> -->
      <el-upload ref="upload" class="upload-demo" :headers="headers" :on-success="handleAvatarSuccess12"
        :on-progress="shangchuan" :on-error="shibai" :data="datas" :action="urls" :file-list="fileList"
        :auto-upload="false">
        <el-button slot="trigger" size="small" type="primary">上传文件</el-button>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button @click="
          dialogVisible3 = false;
        resetFile();
        " size="small">取 消</el-button>
        <el-button type="primary" @click="submitUpload" size="small">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="导入题库" :visible.sync="dialogVisible4" :modal-append-to-body="false" width="30%"
      style="text-align: left" :before-close="importClose">
      <div>
        1、请先下载模板
        <el-link style="float: right" :underline="false" type="primary"
          href="https://file.jingshidata.com/temp/import/%E6%89%B9%E9%87%8F%E5%AF%BC%E5%85%A5%E5%9B%BE%E4%B9%A6%E9%A2%98%E5%BA%93%E6%A8%A1%E6%9D%BF.xlsx">下载模板</el-link>
      </div>
      <div style="margin: 10px 0">2、模板填写完成上传提交</div>
      <el-upload :limit="1" :on-exceed="onExceed" :on-success="chengg" :on-error="chengg1"
        :on-progress="shangchausjffas" class="upload-demo" ref="upload" :headers="headers" :action="urlsyrl()"
        :data="dataimport" :on-preview="handlePreview" :on-remove="handleRemove" @click.native="shangchaun()"
        :file-list="fileList" :auto-upload="false">
        <el-button slot="trigger" size="small" type="primary">导入题库</el-button>
      </el-upload>
      <div style="margin-top: 5px; color: red">
        注意事项：<br />
        1、难易程度、类型、题干、选项（至少两项，最多六项）<br />
        2、难易程度、类型是下拉选择，手动输入无效<br />
        3、正确答案一栏必须是大写字母，多选题用英文逗号“,”分割<br />
        4、红色字体为必填项
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="
          dialogVisible4 = false;
        fileList = [];
        " size="small">取 消</el-button>
        <el-button type="primary" @click="submitUpload" size="small">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :modal-append-to-body="false" class="youcedigao" top="100px" :modal="false" title="导入结果"
      :visible.sync="dialogVisible5" width="30%" style="text-align: left" :before-close="clearDats">
      <el-row id="ID">
        <el-col :span="24" style="font-weight: bold; margin-bottom: 10px">
          成功信息
        </el-col>
        <el-col :span="24"> 成功导入 {{ dats.scount }} 条 </el-col>
        <el-col :span="24" style="font-weight: bold; margin-top: 10px">
          失败信息
        </el-col>
        <el-col :span="24">
          <el-table :data="dats.errorMsgs" border stripe style="width: 100%; margin-top: 15px" highlight-current-row>
            <el-table-column prop="row" label="错误行数" align="center" width="100"></el-table-column>
            <el-table-column prop="msg" label="错误信息" align="center"></el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </el-dialog>
    <div v-if="activeName == '4'">
      <div v-if="worklist.length == 0">本书无作业 <el-button type="primary" @click="tianjias" size="small">添加作业</el-button>
      </div>
      <div v-if="worklist.length > 0">本书有{{ worklist.length }}个作业 <el-button type="primary" @click="tianjias"
          size="small">添加作业</el-button> </div>
      <el-table :data="worklist" border stripe style="width: 100%" highlight-current-row>
        <el-table-column prop="workName" label="作业标题" align="center"></el-table-column>
        <el-table-column label="作业类型" align="center" prop="workName"></el-table-column>
        <el-table-column prop="starNumber" label="完成获得星星" align="center"></el-table-column>
        <!-- <el-table-column label="附件" align="center">
          <template slot-scope="scope">
            <el-button slot="reference" type="text" @click="bianjis1(scope.row)"
              v-if="scope.row.workFileUrl != ''">查看</el-button>
          </template>
        </el-table-column> -->
        <el-table-column label="作业状态" align="center">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.workStatus" :active-value="1" :inactive-value="0"
              @change="worksetWorkStatus(scope.row)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button slot="reference" type="text" @click="bianjis(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog title="添加作业" :visible.sync="dialogVisible7" :modal-append-to-body='false' width="1000px">
      <el-form :model="ruleForms" :rules="ruless" ref="ruleForms" label-width="120px" class="demo-ruleForm">
        <el-form-item label="作业内容" prop="workName">
          <el-input v-model="ruleForms.workName" placeholder="请输入作业内容" style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="作业分类" prop="workType">
          <el-radio-group v-model="ruleForms.workType" @change="zuoyes">
            <el-radio label="1">测评</el-radio>
            <el-radio label="2">作业</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="作业类型" prop="componentId" v-if="ruleForms.workType == '2'">
          <el-radio-group v-model="ruleForms.componentId">
            <el-radio :label="item.id" v-for="item in ponentList" :key="item.id">{{ item.name }}</el-radio>
          </el-radio-group>
          <div v-for="item in ponentList" :key="item.id" v-if="item.id == ruleForms.componentId">{{ item.remark }}</div>
        </el-form-item>
        <el-form-item label="完成作业获得" prop="starNumber">
          <el-input-number :disabled="ruleForms.workType == '1'" :min="1" v-model="ruleForms.starNumber" :step="1"
            step-strictly></el-input-number>
          星
        </el-form-item>
        <el-form-item label="相关文件" prop="sort">
          <el-upload multiple class="upload-demo" :action="upload" :data="datas" :file-list="ruleForms.workFileUrl"
            :on-success="handleAvatarSuccess" :on-remove="handleRemoves">
            <el-button size="small" icon="el-icon-upload">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">支持扩展名：.zip .doc .docx .pdf .jpg.ppt.Mp4.Mp3.xlsx</div>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForms('ruleForms')" size="small">确定</el-button>
          <el-button @click="resetForms('ruleForms')" size="small">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="资源库选择"
      :visible.sync="dialogVisible6"
      :append-to-body="true"
      :modal-append-to-body="false"
      width="1000px"
    >
    <el-form label-width="80px">
            <el-form-item label="资源类型:">
                <el-button type="text" @click="(curPage = 1), (resTypeId = ''), resourcequeryList()"
                    :class="resTypeId === '' ? '' : 'yanse'">全部</el-button>
                <el-button type="text" @click="(curPage = 1), (resTypeId = item.id), resourcequeryList()"
                    :class="resTypeId === item.id ? '' : 'yanse'" v-for="item in resource_typelist" :key="item.id">{{
                        item.name }}</el-button>
            </el-form-item>
            <el-form-item label="资源来源:">
                <el-button type="text" @click="; (curPage = 1), (resSourceId = ''), resourcequeryList()"
                    :class="resSourceId == '' ? '' : 'yanse'">全部</el-button>
                <el-button type="text" @click="(curPage = 1), (resSourceId = item.id), resourcequeryList()"
                    :class="item.id == resSourceId ? '' : 'yanse'" v-for="item in resource_originlist" :key="item.id">{{
                        item.name
                    }}</el-button>
            </el-form-item>
            <el-form-item label="资源阶段:">
                <el-button type="text" @click="(curPage = 1), (resStep = ''), resourcequeryList()"
                    :class="resStep == '' ? '' : 'yanse'">全部</el-button>
                <el-button type="text" @click="; (curPage = 1), (resStep = item.id), resourcequeryList()"
                    :class="item.id == resStep ? '' : 'yanse'" v-for="item in resource_steplist" :key="item.id">{{
                        item.name
                    }}</el-button>
            </el-form-item>
            <el-form-item label="使用对象:">
                <el-button type="text" @click="(curPage = 1), (userType = -1), resourcequeryList()"
                    :class="userType == -1 ? '' : 'yanse'">全部</el-button>
                <el-button type="text" @click="(curPage = 1), (userType = 0), resourcequeryList()"
                    :class="userType == 0 ? '' : 'yanse'">老师使用</el-button>
                <el-button type="text" @click="(curPage = 1), (userType = 1), resourcequeryList()"
                    :class="userType == 1 ? '' : 'yanse'">学生使用</el-button>
            </el-form-item>
        </el-form>
        <div style="display: flex; justify-content: space-between; align-items: center">
            <div>
                <el-select v-model="bookRelation" placeholder="选择是否关联书籍" clearable size="small"
                    @change="(curPage = 1), resourcequeryList()">
                    <el-option label="关联" :value="1">
                    </el-option>
                    <el-option label="不关联" :value="0">
                    </el-option>
                </el-select>
                <el-select v-model="resLimit" placeholder="开放权限" clearable size="small"
                    @change="(curPage1 = 1), resourcequeryList()">
                    <el-option v-for="item in bookLevelList" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>
                <el-input v-model="resTitle" clearable placeholder="请输入搜索关键词" size="small"
                    style="width: 200px"></el-input>
                <!-- <el-input v-model="bookCode" clearable placeholder="请输入图书编号" size="small" style="width: 200px"></el-input> -->
                <el-button type="primary" size="small" @click="(curPage = 1), resourcequeryList()">搜索</el-button>
            </div>
        </div>
        <el-table :row-style="{ height: '48px' }" :header-cell-style="{ background: '#f5f5f5', height: '48px' }"
            style="width: 100%;margin-top: 20px;" border stripe ref="studentTable" :data="TableList"
            @selection-change="handleSelectionChange">
            <el-table-column type="selection" align="center" />
            <el-table-column label="资源名称" prop="resTitle" align="center" ></el-table-column>
            <el-table-column label="资源类型" prop="resTypeTitle" align="center">
            </el-table-column>
            <el-table-column align="center" label="开放权限">
                <template slot-scope="scope">
                    <span v-for="item in bookLevelList" :key="item.id">
                        <span v-if="item.id == scope.row.resLimit">{{ item.name }}</span>
                    </span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="使用对象">
                <template slot-scope="scope">
                    {{ scope.row.userType == 0 ? '教师使用' : '学生使用' }}
                </template>
            </el-table-column>
            <el-table-column label="资源类型" prop="resSourceTitle" align="center">
            </el-table-column>
            <el-table-column label="关联书籍" align="center">
                <template slot-scope="scope">
                    <span v-for="item in scope.row.bookList" :key="item">{{ item }}，</span>
                </template>
            </el-table-column>
            <el-table-column label="置顶" align="center" prop="resSort"></el-table-column>
            <el-table-column label="添加时间" align="center">
                <template slot-scope="scope">
                    {{ scope.row.createTime }}
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页区域 -->
        <el-pagination style="text-align: right; padding: 10px" @prev-click="change" @next-click="change"
            :page-size="10" @current-change="change" background layout="total,prev, pager, next"
            :hide-on-single-page="true" :total="totalCount"></el-pagination>
            <div style="text-align: right;margin: 20px 0;">
                <el-button @click="dialogVisible6 = false">取消</el-button>
                <el-button type="primary" @click="ques">确定</el-button>
            </div>
    </el-dialog>
  </div>
</template>

<script>
import * as homeApi from "@/api/home";
import utils from "@/api/utils";
import { BASE_URL } from "@/api/index";
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
const editorConfig = {
  // JS 语法
  MENU_CONF: {
    uploadImage: {
      server: BASE_URL + "/evaluate//file/oss-upload", //上传图片地址
      customInsert(res, insertFn) {
        // JS 语法
        // res 即服务端的返回结果
        let url = res.data[0].url;
        let alt = "";
        let href = res.data[0].url;
        // 从 res 中找到 url alt href ，然后插入图片
        insertFn(url, alt, href);
      }
    },
    uploadVideo: {
      server: BASE_URL + "/evaluate//file/oss-upload", //上传图片地址
      customInsert(res, insertFn) {
        // JS 语法
        // res 即服务端的返回结果
        let url = res.data[0].url;
        let poster = "";
        // 从 res 中找到 url alt href ，然后插入图片
        insertFn(url, poster);
      }
    }
  }

  // 其他属性...
};

export default {
  data() {
    var validateList = (rule, value, callback) => {
      if (value.length < 2) {
        callback(new Error("请添加至少两个选项"));
      } else {
        callback();
      }
    };
    var validateName = (rule, value, callback) => {
      var flag = true;
      value.map(item => {
        if (item.optionName == "") {
          flag = false;
        }
      });
      if (flag) {
        callback();
      } else {
        callback(new Error("选项不能为空"));
      }
    };
    var validateQuesNum = (rule, value, callback) => {
      if (
        value >
        Number(this.cpForm.simpleNumber) +
        Number(this.cpForm.normalNumber) +
        Number(this.cpForm.difficultyNumber)
      ) {
        callback(new Error("通过题数不得大于总题数"));
      } else {
        callback();
      }
    };
    var validateQuesMin = (rule, value, callback) => {
      if (value < 1) {
        callback(new Error("通过题数至少为1"));
      } else {
        callback();
      }
    };

    return {
      headers: {
        token: "" //文件上传请求头
      },
      fileList: [],
      dats: {},
      isDetail: false,
      labels: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"],
      editor1: null,
      toolbarConfig: {
        excludeKeys: ["group-video", "fullScreen"]
      },
      editorConfig: editorConfig,
      mode: "default", // or 'simple'
      lessonId: "",
      dialogVisible2: false,
      dialogVisible3: false,
      dialogVisible4: false,
      dialogVisible5: false,
      prevFile: "",
      dialogVisible1: false,
      loading: false,
      activeName: "1",
      dialogVisible: false,
      inputVisible: false,
      inputValue: "",
      datas: {
        bucketId: 2
      },
      dataimport: {
        bookId: 0
      },
      dataw: {
        isDown: 0
      },
      stForm: {
        questionLevel: "",
        questionType: 0,
        questionName: "",
        readQuestionOptionsList: [],
        questionAnalysis: "",
        rightAnswer: "",
        isAdditional: 0,
        id: ""
      },
      strules: {
        questionLevel: [
          { required: true, message: "请选择试题等级", trigger: "change" }
        ],
        isAdditional: [
          { required: true, message: "请选择是否是附加题", trigger: "change" }
        ],
        questionType: [
          { required: true, message: "请选择试题类型", trigger: "change" }
        ],
        questionName: [
          { required: true, message: "请输入题干", trigger: "blur" }
        ],
        readQuestionOptionsList: [
          {
            required: true,
            message: "请添加至少两个选项",
            validator: validateList
          },
          { required: true, message: "选项不能为空", validator: validateName }
        ]
        // rightAnswer: [{ required: true, message: '请设置正确选项', trigger: 'change' }]
      },
      cpForm: {
        answerTime: 3,
        paperNumber: "",
        additionalNumber: "",
        difficultyNumber: "",
        isPassNumber: "",
        normalNumber: "",
        simpleNumber: ""
      },
      cprules: {
        answerTime: [
          { required: true, message: "请输入答题时间", trigger: "blur" }
        ],
        difficultyNumber: [
          { required: true, message: "请输入较难题数", trigger: "blur" }
        ],
        isPassNumber: [
          { required: true, message: "请输入通过题数", trigger: "blur" },
          {
            required: true,
            message: "通过题数不得大于总题数",
            validator: validateQuesNum,
            trigger: "blur"
          },
          {
            required: true,
            message: "通过题数最小为1",
            validator: validateQuesMin,
            trigger: "blur"
          }
        ],
        normalNumber: [
          { required: true, message: "请输入普通题数", trigger: "blur" }
        ],
        simpleNumber: [
          { required: true, message: "请输入较易题数", trigger: "blur" }
        ],
        paperNumber: [
          { required: true, message: "请输入允许测评次数", trigger: "blur" }
        ]
      },
      rules: {
        // specialColumnCode: [{ required: true, message: '请选择所属专栏', trigger: 'change' }],
        publishingId: [
          { required: true, message: "请选择书籍出版社", trigger: "change" }
        ],
        classifyIdList: [
          { required: true, message: "请选择书籍分类", trigger: "change" }
        ],
        complatePaperNumber: [
          { required: true, message: "请选择完成测评星星值", trigger: "change" }
        ],
        endReadNumber: [
          { required: true, message: "请选择结束阅读星星值", trigger: "change" }
        ],
        startReadNumber: [
          { required: true, message: "请选择开始阅读星星值", trigger: "change" }
        ],
        summitFeelNumber: [
          {
            required: true,
            message: "请选择提交读后感星星值",
            trigger: "change"
          }
        ],
        // bookStarNumber: [{ required: true, message: '请选择书籍星星数量', trigger: 'change' }],
        bookImgUrl: [
          { required: true, message: "请上传书籍封面", trigger: "change" }
        ],
        bookGrades: [
          { required: true, message: "请选择适用年级", trigger: "change" }
        ],
        bookCode: [
          { required: true, message: "请输入书籍编号", trigger: "blur" }
        ],
        bookAuthor: [
          { required: true, message: "请输入书籍作者", trigger: "blur" }
        ],
        wordNumber: [
          { required: true, message: "请输入图书字数", trigger: "blur" }
        ],
        bookName: [
          {
            required: true,
            message: "请输入书籍名称",
            trigger: "change"
          }
        ]
      },
      ruleForm: {
        bookName: "",
        bookAuthor: "",
        bookCode: "",
        bookGrades: [],
        bookImgUrl: "",
        serverHttp: "",
        complatePaperNumber: 1,
        endReadNumber: 1,
        startReadNumber: 1,
        summitFeelNumber: 1,
        // bookStarNumber: 0,
        classifyIdList: [],
        publishingId: "",
        specialColumnCode: [],
        wordNumber: "",
        bookIntro: "",
        bookLevel: "",
        additionalNumber: "",
        serverId: ""
      },
      cList: [],
      options: [], //模块
      gradelist: [], //年级列表
      bookLevelList: [], //图书等级
      specialColumnList: [], //阅读专栏
      headers: {
        token: "" //文件上传请求头
      },
      resType: "",
      fileList: [],
      publishingList: [],
      questionList: [],
      levelList: [],
      worklist: [],
      radio: "",
      checkBox: [],
      ruleForms: {
        id: "",
        workType: '',
        workName: '',
        componentId: '',
        componentName: '',
        starNumber: 0,
        workFileUrl: [],
        serverId: ''
      },
      ruless: {
        starNumber: [
          {
            required: true,
            message: "请输入星星数量",
            trigger: "blur"
          }
        ],
        componentId: [
          {
            required: true,
            message: "请选择分类",
            trigger: "blur"
          }
        ],
        workName: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur"
          }
        ],
        workType: [
          {
            required: true,
            message: "请选择类型",
            trigger: "blur"
          }
        ],
      },
      dialogVisible7: false,
      paperRule: {
        simpleNumber: 0,
        normalNumber: 0,
        difficultyNumber: 0,
        answerTime: 0,
        isPassNumber: 0
      },
      seeItem: {
        starRuleObj: {},
        readClassifyBookList: []
      },
      resList: [],
      schoolId: "",
      urls: BASE_URL + '/evaluate//file/oss-upload', //上传图片地址
      upload: BASE_URL + "/evaluate/file/oss-upload",
      ponentList: [],
      resLimit: '',
                    bookRelation: '',
                    resTitle: '',
                    TableList:[],
                    totalCount:0,
                    multipleSelection:[],
                    resTypeId: '',
                    resSourceId: '',
                    resource_typelist:[],
                    resTypeId: '',
                    resSourceId: '',
                    resStep: '',
                    userType: -1,
                    resource_steplist:[],
                    resource_originlist:[],
                    dialogVisible6:false
    };
  },
  created() {
    this.schoolId = JSON.parse(localStorage.getItem("info")).schoolId;
    if (this.$route.query.modeType) {
      this.isDetail = true;
    }
    this.ruleForm.id = this.$route.query.id || "";
    this.headers.token = localStorage.getItem("token");
    this.getTreeReadClassify();
    this.dictcode();
    this.dictcode1();
    this.dictcode2();
    this.gradegradelist();
    this.getPublishingList();
    this.getRestype();
    this.workgetListByBookId()
    this.ComponentList()
    this.dictcodes()
    this.dictcodes1()
    this.dictcodes2()
    this.resourcequeryList()
  },
  watch: {},
  methods: {
    removeresource(item) {
      this.$confirm('此操作将解除与该资源的绑定, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let params = {
            id: item.id,
            resId:item.resId,
            bookId: this.ruleForm.id
          }
          homeApi.removeresource(params).then((res) => {
            if (res.data.code == 0) {
              this.getResourceByBookId()
              this.$message({
                message: '解除成功',
                type: 'success'
              })
            }
          })
        })
        .catch(() => {})
    },
    dictcodes1() {
            let that = this
            homeApi
                .dictcode({
                    code: 'resource_origin'
                })
                .then((res) => {
                    that.resource_originlist = res.data.data
                })
        },
        dictcodes2() {
            let that = this
            homeApi
                .dictcode({
                    code: 'resource_step'
                })
                .then((res) => {
                    that.resource_steplist = res.data.data
                })
        },
    dictcodes() {
            let that = this
            homeApi
                .dictcode({
                    code: 'resource_type'
                })
                .then((res) => {
                    that.resource_typelist = res.data.data
                })
        },
    change(s) {
            this.curPage = s
            this.resourcequeryList()
        },
        resourcequeryList() {
            let that = this
            homeApi
                .resourcequeryList({
                    curPage: this.curPage,
                    pageSize: 10,
                    resTypeId: this.resTypeId,
                    resSourceId: this.resSourceId,
                    resStep: this.resStep,
                    userType: this.userType == -1 ? '' : this.userType,
                    resLimit: this.resLimit,
                    bookRelation: this.bookRelation,
                    resTitle: this.resTitle
                })
                .then((res) => {
                    this.TableList = res.data.data.dataList
                    this.totalCount = res.data.data.totalCount
                })
        },
    handleSelectionChange(val) {
            this.multipleSelection = val
            console.log(val)
        },
    ques() {
            if (this.multipleSelection.length == 0) {
                this.$message({
                    type: 'info',
                    message: '请选择资源!'
                })
            } else {
                let that = this
                let resIds = []
                for (var i = 0; i < this.multipleSelection.length; i++) {
                    resIds.push(this.multipleSelection[i].resId)
                }
                // return false
                let params = {
                    bookIds: this.ruleForm.id,
                    resIds: resIds.toString(),
                }
                homeApi
                    .resourcelinkBook(params)
                    .then((res) => {
                        this.dialogVisible6 = false
                        this.getResourceByBookId()
                    })
                    .catch(() => { })

            }
        },
    bianjis(s) {
      this.ruleForms = s
      this.ruleForms.workType = this.ruleForms.workType.toString()
      let workFileUrl =s.workFileUrl!=''? s.workFileUrl.split(","):[]
      let list = []
      for (var i = 0; i < workFileUrl.length; i++) {
        list.push({
          name: workFileUrl[i],
          fileUrl: workFileUrl[i],
          serverHttp: this.ruleForms.serverHttp
        })
      }
      this.ruleForms.workFileUrl = list
      this.dialogVisible7 = true
    },
    bianjis1(s){
            this.$router.push({
                path: '/pdf',
                query: {
                    url:s.serverHttp+s.workFileUrl
                }
            })
        },
    ComponentList() {
      let that = this
      homeApi
        .ComponentList({
          typeCode: 'YUEDU'
        })
        .then((res) => {
          this.ponentList = res.data.data
        })
    },
    zuoyes() {
      if (this.ruleForms.workType == '1') {
        this.ruleForms.starNumber = this.ruleForm.complatePaperNumber
      }
    },
    resetForms(formName) {
      this.$refs[formName].resetFields();
      this.dialogVisible7 = false;
    },
    submitForms(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let that = this
          let componentName = ''
          for (var i = 0; i < that.ponentList.length; i++) {
            if (that.ruleForms.componentId == that.ponentList[i].id) {
              componentName = that.ponentList[i].name
            }
          }
          let workFileUrl = []
          for (var i = 0; i < that.ruleForms.workFileUrl.length; i++) {
            workFileUrl.push(that.ruleForms.workFileUrl[i].fileName)
          }
          let params = {
            id: that.ruleForms.id,
            bookId: that.ruleForm.id,
            workName: that.ruleForms.workName,
            workType: that.ruleForms.workType,
            componentId: that.ruleForms.componentId,
            componentName: componentName,
            starNumber: that.ruleForms.starNumber,
            workFileUrl: workFileUrl.toString()
          }
          // console.log(params)
          homeApi.worksave(params).then((res) => {
            that.workgetListByBookId()
            that.dialogVisible7 = false
            that.$message({
              message: '保存成功',
              type: 'success'
            })
          })
        } else {
          return false
        }
      })
    },
    handleAvatarSuccess(res, file) {
      res.data[0].name = res.data[0].originalFilename
      res.data[0].fileName = res.data[0].fileName
      res.data[0].fileUrl = res.data[0].fileName
      res.data[0].fileSize = res.data[0].size
      this.ruleForms.workFileUrl.push(res.data[0])
    },
    handleRemoves(res, file) {
      this.ruleForms.workFileUrl = file
    },
    tianjia(){
      this.$router.push({
                path: '/resourcesadd',
                query: {
                  bookId:this.ruleForm.id
                }
            })
    },
    tianjias() {
      this.ruleForms = {
        id: "",
        workType: '',
        workName: '',
        componentId: '',
        componentName: '',
        starNumber: 0,
        workFileUrl: [],
        serverId: ''
      }
      this.dialogVisible7 = true
    },
    workgetListByBookId() {
      let that = this
      homeApi
        .workgetListByBookId({
          bookId: this.ruleForm.id
        })
        .then((res) => {
          this.worklist = res.data.data
        })
    },
    onExceed() {
      this.$message.error("一次只能上传一个文件!");
    },
    preview(item) {
      let url = item.serverHttp + item.fileUrl;
      window.open(url, "_blank");
    },
    shangchaun() {
      this.dataimport.bookId = this.ruleForm.id;
    },
    clearDats(done) {
      this.dats = {};
      done();
    },
    importClose(done) {
      this.fileList = [];
      done();
    },
    shangchausjffas() {
      this.loading = true;
    },
    handleRemove(file, fileList) { },
    handlePreview(file) { },
    submitUpload() {
      this.$refs.upload.submit();
    },
    urlsyrl() {
      return BASE_URL + "/read/import/importQuestion";
    },
    chengg(data) {
      this.loading = false;
      this.dialogVisible4 = false;
      this.fileList = [];
      this.getListByBookId();
      this.getBookDetail();
      if (data.code == 0) {
        this.dats = data.data;
        this.dialogVisible5 = true;
        this.$message({
          message: "上传成功",
          type: "success"
        });
      } else {
        this.$message({
          message: "上传失败",
          type: "success"
        });
        this.$message(data.msg);
      }
    },
    chengg1() {
      this.loading = false;
      this.$message("上传失败");
    },
    daoru() {
      this.dialogVisible4 = true;
    },
    opsChange(e) {
      this.$set(this.ruleForm, "classifyIdList", e);
      // console.log(this.ruleForm.classifyIdList)
    },
    getNameById(id, targetList, idName, name) {
      let result = "暂无";
      let index = targetList.findIndex(i => {
        return i[idName] == id;
      });
      if (index != -1) {
        result = targetList[index][name];
      }
      return result;
    },
    delOption(indent, list, index, type) {
      if (type == 1) {
        if (this.radio == index) {
          this.radio = "";
        }
      } else {
        let anIndex = this.checkBox.findIndex(answer => {
          return answer == index;
        });
        if (anIndex != -1) {
          this.checkBox.splice(anIndex, 1);
        }
      }
      let oindex = list.readQuestionOptionsList.indexOf(child => {
        return child.optionSort == indent.optionSort;
      });
      list.readQuestionOptionsList.splice(oindex, 1);
    },
    delRes(item) {
      this.$confirm("此操作将删除该资源, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let params = {
            id: item.id,
            bookId: this.ruleForm.id
          };
          homeApi.delRes(params).then(res => {
            if (res.data.code == 0) {
              this.getResourceByBookId();
              this.$message({
                message: "删除成功",
                type: "success"
              });
            }
          });
        })
        .catch(() => { });
    },
    setcp() {
      if (this.paperRule) {
        this.cpForm = JSON.parse(JSON.stringify(this.paperRule));
      }
      this.dialogVisible = true;
    },
    resetOptions() {
      this.$nextTick(() => {
        this.stForm.readQuestionOptionsList = [];
        this.stForm.rightAnswer = "";
      });
    },
    delQuestion(item) {
      this.$confirm("此操作将删除该试题, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let params = {
            id: item.id,
            bookId: this.ruleForm.id
          };
          homeApi.delQuestion(params).then(res => {
            if (res.data.code == 0) {
              this.getBookDetail();
              this.getListByBookId();
              this.$message({
                message: "删除成功",
                type: "success"
              });
            }
          });
        })
        .catch(() => { });
    },
    editQuestion(item) {
      this.stForm = JSON.parse(JSON.stringify(item));
      if (this.stForm.questionType === 0) {
        let index = this.labels.findIndex(item => {
          return item === this.stForm.rightAnswer;
        });
        this.radio = index;
      } else if (this.stForm.questionType === 1) {
        let answer = this.stForm.rightAnswer.split(",");
        let indexs = [];
        answer.map(an => {
          let index = this.labels.findIndex(item => {
            return item === an;
          });
          indexs.push(index);
        });
        this.checkBox = indexs;
      }
      this.dialogVisible1 = true;
    },
    saveReadQuestion() {
      this.$refs.stForm.clearValidate();
      this.$refs.stForm.validate(valid => {
        if (valid) {
          if (this.stForm.questionType === 0) {
            if (this.radio === "") {
              this.$message.error("请设置正确答案");
              return;
            }
          } else if (this.stForm.questionType === 1) {
            if (this.checkBox.length == 0) {
              this.$message.error("请设置正确答案");
              return;
            } else if (this.checkBox.length < 2) {
              this.$message.error("请设置至少两个正确答案");
              return;
            }
          }
          let that = this;
          let params = JSON.parse(JSON.stringify(that.stForm));
          params.bookId = this.ruleForm.id;
          if (params.questionType === 0) {
            params.rightAnswer = this.labels[this.radio];
          } else if (params.questionType === 1) {
            let answer = [];
            this.checkBox.map(item => {
              answer.push(this.labels[item]);
            });
            params.rightAnswer = answer.join(",");
          }
          homeApi.saveReadQuestion(params).then(res => {
            if (res.data.code == 0) {
              this.dialogVisible1 = false;
              this.resetST();
              that.getBookDetail();
              this.getListByBookId();
              this.workgetListByBookId()
              that.$message({
                message: "添加成功",
                type: "success"
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    pushOption() {
      let ops = {
        optionLabel: this.labels[this.stForm.readQuestionOptionsList.length],
        optionName: "",
        optionSort: this.stForm.readQuestionOptionsList.length + 1
      };
      this.stForm.readQuestionOptionsList.push(ops);
    },
    setUpPaperRule() {
      if (
        Number(this.cpForm.simpleNumber) +
        Number(this.cpForm.normalNumber) +
        Number(this.cpForm.difficultyNumber) ==
        0
      ) {
        this.$message.error("至少设置一道题！");
        return;
      }
      this.$refs["cpForm"].validate(valid => {
        if (valid) {
          let that = this;
          let params = { id: this.ruleForm.id };
          params.rule = JSON.parse(JSON.stringify(that.cpForm));
          homeApi.setUpPaperRule(params).then(res => {
            if (res.data.code == 0) {
              this.dialogVisible = false;
              this.resetCP();
              that.getBookDetail();
              this.workgetListByBookId()
              that.$message({
                message: "设置成功",
                type: "success"
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    stClose(done) {
      this.resetST();
      done();
    },
    resetST() {
      this.stForm = {
        questionLevel: "",
        questionType: 0,
        questionName: "",
        readQuestionOptionsList: [],
        questionAnalysis: "",
        rightAnswer: "",
        isAdditional: 0,
        id: ""
      };
      this.radio = "";
      this.checkBox = [];
      this.$nextTick(() => {
        this.$refs.stForm.clearValidate();
      });
    },
    cpClose(done) {
      this.resetCP();
      done();
    },
    resetCP() {
      this.cpForm = {
        answerTime: 3,
        paperNumber: "",
        additionalNumber: "",
        difficultyNumber: "",
        isPassNumber: "",
        normalNumber: "",
        simpleNumber: ""
      };
    },
    getListByBookId() {
      let that = this;
      let params = {
        bookId: this.ruleForm.id
      };
      homeApi
        .getListByBookId(params)
        .then(res => {
          that.questionList = res.data.data;
        })
        .catch(() => { });
    },
    downLoad(item) {
      location.href = item.serverHttp + item.fileUrl;
    },
    submitUpload() {
      // console.log(this.fileList)
      // else if (this.fileList.length == 0) {
      //   this.$message.error('请选择上传文件！')
      //   return
      // }
      this.$refs.upload.submit();
    },
    onCreated1(editor) {
      this.editor1 = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
    },
    handlePreview(file) {
      console.log(file);
      let fileUrl;
      if (file.url) {
        fileUrl = file.url;
      } else {
        fileUrl = file.serverHttp + file.fileUrl;
      }
      this.prevFile = {
        url: fileUrl,
        fileType: utils.getFileType(fileUrl)
      };
      this.dialogVisible2 = true;
    },
    xunahj(s) {
      s.forEach(item => {
        item.value = item.id;
        item.label = item.classifyName;
        if (item.chilrenList && item.chilrenList.length > 0) {
          item.children = item.chilrenList;
          this.xunahj(item.children);
        }
      });
      return s;
    },
    goBack() {
      this.$router.go(-1);
    },
    getPublishingList() {
      let that = this;
      homeApi
        .getPublishingList()
        .then(res => {
          that.publishingList = res.data.data;
        })
        .catch(() => { });
    },
    getTreeReadClassify() {
      let that = this;
      let params = {
        schoolId: -1
      };
      homeApi
        .getTreeReadClassify(params)
        .then(res => {
          res.data.data = that.xunahj(res.data.data);
          that.options = res.data.data;
          if (this.ruleForm.id != "") {
            this.getBookDetail();
            this.getListByBookId();
            this.getResourceByBookId();
          }
        })
        .catch(() => { });
    },
    //年级列表
    getGradeStage() {
      let that = this;
      homeApi
        .getGradeStage({
          stage: 5
        })
        .then(res => {
          that.gradelist = res.data.data;
        });
    },
    gradegradelist() {
      let params = {
        schoolId: this.schoolId
      };
      homeApi
        .gradegradelist(params)
        .then(res => {
          this.gradelist = res.data.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          console.log(this.ruleForm);
          let that = this;
          let params = JSON.parse(JSON.stringify(that.ruleForm));
          // params.schoolId = this.schoolId
          params.starRuleObj = {
            complatePaperNumber: params.complatePaperNumber,
            endReadNumber: params.endReadNumber,
            startReadNumber: params.startReadNumber,
            summitFeelNumber: params.summitFeelNumber
          };
          params.specialColumnCode = params.specialColumnCode.join(",");
          let gradeNames = this.getNamesByIds(
            params.bookGrades,
            this.gradelist,
            "gradeId",
            "name"
          );
          params.bookGrades = params.bookGrades.join(",");
          params.bookGradesName = gradeNames.join(",");
          let publishingName = this.getNamesByIds(
            [params.publishingId],
            this.publishingList,
            "id",
            "publishingName"
          );
          params.publishingName = publishingName.join(",");
          params.classifyIdList = [
            params.classifyIdList[params.classifyIdList.length - 1]
          ];
          params.schoolId=JSON.parse(localStorage.getItem("info")).schoolId;
          // console.log(params)
          homeApi.saveReadBooks(params).then(res => {
            that.ruleForm.id = res.data.data;
            that.getBookDetail();
            that.activeName = "2";
            that.$message({
              message: "保存成功",
              type: "success"
            });
          });
        } else {
          return false;
        }
      });
    },
    getNamesByIds(ids, targetList, idName, name) {
      let result = [];
      ids.map(id => {
        let index = targetList.findIndex(i => {
          return i[idName] == id;
        });
        if (index != -1) {
          result.push(targetList[index][name]);
        }
      });
      return result;
    },
    //课程详情
    getBookDetail() {
      let that = this;
      homeApi
        .getBookDetail({
          id: that.ruleForm.id
        })
        .then(res => {
          if (this.isDetail) {
            that.seeItem = res.data.data;
          }
          this.dedit = true;
          if (!res.data.data.specialColumnCode) {
            res.data.data.specialColumnCode = "";
          }
          that.ruleForm = res.data.data;
          that.ruleForm.specialColumnCode = that.ruleForm.specialColumnCode
            ? that.ruleForm.specialColumnCode.split(",")
            : [];
          that.ruleForm.bookGrades = that.ruleForm.bookGrades
            ? that.ruleForm.bookGrades.split(",")
            : [];
          if (that.ruleForm.readClassifyBookList) {
            let classifyList = [];
            that.ruleForm.readClassifyBookList.map(item => {
              classifyList.push(item.classifyId);
            });
            that.ruleForm.classifyIdList = classifyList;
          } else {
            that.ruleForm.classifyIdList = [];
          }
          that.ruleForm.classifyIdList = that.getParentIdList(
            this.options,
            that.ruleForm.readClassifyBookList[0].classifyId
          );
          if (res.data.data.paperRule) {
            this.paperRule = JSON.parse(res.data.data.paperRule);
          }
          if (res.data.data.starRule) {
            let rule = JSON.parse(res.data.data.starRule);
            that.ruleForm.complatePaperNumber = rule.complatePaperNumber;
            that.ruleForm.endReadNumber = rule.endReadNumber;
            that.ruleForm.startReadNumber = rule.startReadNumber;
            that.ruleForm.summitFeelNumber = rule.summitFeelNumber;
          }
          console.log(that.ruleForm);
        });
    },
    getParentIdList(list, id) {
      if (!list || !id) {
        return "";
      }
      let arr = [];
      let findParent = (data, nodeId, parentId) => {
        for (var i = 0, length = data.length; i < length; i++) {
          let node = data[i];
          //由于后端返回的树状结构数组里面的value值为string类型,所以为了避免判断全等有问题,所以将传入的城市id使用toString进行了类型转换
          if (node.id === nodeId) {
            arr.unshift(nodeId);
            if (nodeId === list[0].id) {
              break;
            }
            findParent(list, parentId);
            break;
          } else {
            if (node.chilrenList) {
              findParent(node.chilrenList, nodeId, node.id);
            }
            continue;
          }
        }
        return arr;
      };
      return findParent(list, id);
    },
    handleAvatarSuccess2(res) {
      this.ruleForm.serverHttp = res.data[0].url.replace(
        res.data[0].fileName,
        ""
      );
      this.ruleForm.bookImgUrl = res.data[0].fileName;
      this.ruleForm.serverId = res.data[0].bucketId;
    },
    handleExceed(files, fileList) {
      this.$message.warning(`只能上传一个学习内容！如需更换请删除原有内容！`);
    },
    handleAvatarSuccessk(res) {
      console.log(res);
      let data = {
        fileFormat: res.data[0].fileNameSuffix,
        fileMime: res.data[0].fileNameSuffix,
        fileSize: res.data[0].size,
        md5: res.data[0].md5,
        fileUrl: res.data[0].fileName,
        restypeId: this.filetypeid,
        name: res.data[0].originalFilename,
        url: res.data[0].url,
        fileUrl: res.data[0].url,
        fileName: res.data[0].fileName
      };
      this.lesslist.fileModel.push(data);
    },
    handleRemove(file, fileList) {
      for (var i = 0; i < this.lesslist.fileModel.length; i++) {
        if (file.fileName == this.lesslist.fileModel[i].fileName) {
          this.lesslist.fileModel.splice(i, 1);
        }
      }
    },
    getRestype() {
      let that = this;
      let params = {
        code: "read_resource_type"
      };
      homeApi
        .dictcode(params)
        .then(res => {
          that.Restypelist = res.data.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    handleAvatarSuccess12(res, file) {
      let that = this;
      let params = {
        serverId: res.data[0].bucketId,
        bookId: that.ruleForm.id,
        fileUrl: res.data[0].fileName,
        resourceName:
          that.ruleForm.bookName +
          " " +
          that.resType.name +
          "-" +
          res.data[0].originalFilename,
        fileName: res.data[0].originalFilename,
        fileSize: res.data[0].size,
        resourceType: that.resType.code
      };
      homeApi
        .saveReadResource(params)
        .then(res => {
          if (res.data.code == 0) {
            that.dialogVisible3 = false;
            this.getResourceByBookId();
            that.$message({
              type: "success",
              message: "上传成功!"
            });
          }
          that.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getResourceByBookId() {
      let params = {
        bookId: this.ruleForm.id
      };
      homeApi
        .getResourceByBookId(params)
        .then(res => {
          if (res.data.code == 0) {
            this.resList = res.data.data;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    fileClose(done) {
      this.resetFile();
      done();
    },
    resetFile() {
      this.dataw.isDown = 0;
    },
    shangchuan() {
      this.loading = true;
    },
    shibai() {
      this.$message("上传失败！");
      this.loading = false;
    },
    restypeMime(v) {
      let strfile = "";
      let exts = v.split(",");
      exts.forEach(res => {
        let list = utils.getUploadType(res);
        strfile += list.name + ",";
      });
      strfile =
        strfile != "" ? strfile.substring(0, strfile.length - 1) : strfile;
      return strfile;
    },
    dictcode2() {
      let that = this;
      homeApi
        .dictcode({
          code: "book_level"
        })
        .then(res => {
          that.bookLevelList = res.data.data;
        });
    },
    dictcode1() {
      let that = this;
      homeApi
        .dictcode({
          code: "question_level"
        })
        .then(res => {
          that.levelList = res.data.data;
        });
    },
    dictcode() {
      let that = this;
      homeApi
        .dictcode({
          code: "special_column"
        })
        .then(res => {
          that.specialColumnList = res.data.data;
        });
    }
  },
  components: {
    Editor,
    Toolbar
  }
};
</script>

<style lang="less" scoped>
.yanse {
  color: #999;
}

.jxui {
  margin-top: 15px;
  width: 100%;
}

.hjufi {
  border-right: 5px solid #eee;
}

.heiji1 {
  margin-right: 0.5rem;
  line-height: 50px;
  width: 100px;
  height: 50px;
  color: #666;
}

.xu {
  border: 1px #e4e4e4 dashed;
  border-radius: 0.2rem;
}

.cursor {
  cursor: pointer;
}

.lanse {
  color: #409eff;
  margin-left: 10px;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 200px;
  height: 240px;
  line-height: 240px;
  text-align: center;
}

.avatar {
  width: 200px;
  height: 240px;
  display: block;
}

.xuanhjifas {
  cursor: pointer;
  margin: 5px 0;
}

.kechns {
  font-size: 18px !important;
  background-color: #409eff;
  color: #fff;
  padding: 8px;
  text-align: center;
  cursor: pointer;
}

.huangse {
  color: #e6a23c;
}

.mat {
  margin-top: 15px;
}

.xuanhjifas {
  padding: 10px 20px;
  cursor: pointer;
}

.xuanhjifas:hover {
  border-color: #b3d8ff;
  color: #409eff;
  background: #ecf5ff;
}

.xuanhjjssss {
  border-color: #b3d8ff;
  color: #fff;
  background: #409eff;
}

.dasgasdg {
  font-size: 16px !important;
  cursor: pointer;
  margin-top: 5px;
}

.rit {
  text-align: right;
}

a {
  text-decoration: none;
  color: #409eff;
}

a:hover,
a:visited,
a:link,
a:active {
  color: #409eff;
  // 设置使所有a标签的四种状态都和本身颜色保持一致，样式代码自己写
}

.spb {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.stForm /deep/ .el-form-item {
  margin-bottom: 10px;
}

.questionItem {
  margin-bottom: 10px;
  font-weight: 600;
}

.mr-10 {
  margin-right: 10px;
}

.richText /deep/ img {
  max-width: 100% !important;
}

.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader /deep/ .el-upload:hover {
  border-color: #409eff;
}

.youcedigao /deep/ .el-dialog {
  margin: 0 40px 50px 0;
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/read/newly.vue